//@ts-check
/**
 * @param {unknown} file
 * @returns {boolean}
 */
export function isImageObjectBrowser(file) {
  return file && file['@type'] && file['@type'] == 'Image';
}
